var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app-bar',{attrs:{"app":"","color":"primary","dark":"","height":"57.1"}},[_c('v-spacer'),_c('v-toolbar-items',[_c('v-btn',{attrs:{"icon":"","large":"","text":""},on:{"click":_vm.changeTheme}},[_c('v-icon',[_vm._v(" "+_vm._s(this.$vuetify.theme.dark ? 'dark_mode' : 'light_mode')+" ")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }